$('#promo').ready(function() {
    if (window.location.pathname.split('/')[1] == 'promo' && window.location.pathname.split('/').length == 2) {
        promo_load();
    }
});

$('#promo_type_select').on('change', promo_update);

$('.promo_serach_btn').on('click', promo_update);

$('#promo_search').on('keyup', promo_update);

function promo_load() {
    Swal.fire({
        title: 'Загружаем, ожидайте',
        allowOutsideClick: false,
        allowEscapeKey: false,
        heightAuto: false,
        footer: '<a id = "MailSupport" theme = "Ошибка в при загрузке" href = "javascript:void();">Написать в службу поддержки</a>',
        onBeforeOpen: () => {
            Swal.showLoading()
        }
    });
    $.get('/promo', { type: $('#promo_type_select').val(), search: $('#promo_search').val() }, function(data) {
        $('#promo_areas').html(data);
        Swal.close();
        $('body').addClass("app-documents");
    });
}

function promo_update() {
    let areas = $('.a1');
    let numType = -1;
    areas.hide();

    if ( $('#promo_type_select').val() == '0000' && ($('#promo_search').val() == 0) ) {
        areas.show();
    } else {
        for (var i = $('#promo_type_select').val().length - 1; i >= 0; i--) {
            if ($('#promo_type_select').val().toString()[i] == 1) {
                numType = i;
            };
        };
    areas.each(function (index, element) {
        let checkType = $(element).data('type').toString()[numType] == $('#promo_type_select').val()[numType];
        let checkSearch = $(element).data('title').toLowerCase().includes($('#promo_search').val().toLowerCase());
            if ( $('#promo_search').val() == 0 && checkType ) {
                $(element).show();
            };

            if ( numType == -1 && $('#promo_search').val() != 0 && checkSearch ){
                $(element).show();
            };

            if ( numType != -1 && $('#promo_search').val() != 0 && checkType && checkSearch ) {
                $(element).show();
            };
        });
    };
}


$('.promo_request_buy').on('click', function() {
    Swal.fire({
        titleText: 'Оставить заявку на обратный звонок',
        text: $('#breadcrumb-main-name').html(),
        input: 'textarea',
        inputPlaceholder: 'Введите сообщение...',
        width: 600,
        confirmButtonText: 'Отправить',
        showCancelButton: true,
        cancelButtonText: 'Закрыть',
        footer: '<a id = "MailSupport" theme = "Ошибка в запросе на промо-доступ" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
        showLoaderOnConfirm: true,
        focusConfirm: false,
        target: 'body',
        preConfirm: (message) => {
            Swal.disableInput();
            var data = new FormData()
            data.append('topic', $('#breadcrumb-main-name').html())
            data.append('message', message)
            return fetch('/alert/service/support', { method: "POST", headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }, body: data })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(response.statusText)
                    }
                    return response.json()
                })
                .then((data) => {
                    if (data.status == 'error' || data.status == 'warning') {
                        Swal.showValidationMessage(data.message);
                    }
                    Swal.enableInput();
                    return data;
                })
                .catch((error) => {
                    Swal.showValidationMessage(error);
                    Swal.enableInput();
                });
        },
        allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
        if (result.value.status !== undefined) Swal.fire({ icon: result.value.status, title: result.value.message });
    })
});


$('.promo_request_buy_module').on('click', function() {
    Swal.fire({
        titleText: 'Оставить заявку на обратный звонок',
        text: $('#breadcrumb-main-name').html(),
        input: 'textarea',
        inputPlaceholder: 'Введите сообщение...',
        width: 600,
        confirmButtonText: 'Отправить',
        showCancelButton: true,
        cancelButtonText: 'Закрыть',
        footer: '<a id = "MailSupport" theme = "Ошибка в запросе модуля" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
        showLoaderOnConfirm: true,
        focusConfirm: false,
        target: 'body',
        preConfirm: (message) => {
            Swal.disableInput();
            var data = new FormData()
            data.append('topic', $('#promo_module_name').html())
            data.append('message', message)
            return fetch('/alert/service/support', { method: "POST", headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }, body: data })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(response.statusText)
                    }
                    return response.json()
                })
                .then((data) => {
                    if (data.status == 'error' || data.status == 'warning') {
                        Swal.showValidationMessage(data.message);
                    }
                    Swal.enableInput();
                    return data;
                })
                .catch((error) => {
                    Swal.showValidationMessage(error);
                    Swal.enableInput();
                });
        },
        allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
        if (result.value.status !== undefined) Swal.fire({ icon: result.value.status, title: result.value.message });
    })
});

//Artur
function checkEmail(string) {
    var pattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,6}\.)?[a-z]{2,6}$/i;
    if ((string != 0) && (pattern.test(string))) return true;
    return false;
}

$(document).on("click", ".send-request", function() {

    if (checkEmail(document.getElementById('form-request2-' + $(this).attr('data-numForm')).value)) {
        $.post('/api/hserm', {
            type: 1,
            auth_token: 'secret_token_plin2k',
            name: document.getElementById('form-request1-' + $(this).attr('data-numForm')).value,
            email: document.getElementById('form-request2-' + $(this).attr('data-numForm')).value,
            organization: document.getElementById('form-request3-' + $(this).attr('data-numForm')).value,
            nameProgram: document.getElementById('form-request4-' + $(this).attr('data-numForm')).value,
            comment: document.getElementById('form-request5-' + $(this).attr('data-numForm')).value,
            countStudent: document.getElementById('form-request6-' + $(this).attr('data-numForm')).value,
            formStudy: document.getElementById('form-request7-' + $(this).attr('data-numForm')).value
        }, function(response) {
            var data = response.split('|');
            if (data[0] == 'success') {
                Swal.fire({ icon: data[0], title: data[1] });
            } else {
                Swal.showValidationMessage(data[1]);
            }

        });

    }

    //$(this).attr('data-numForm')
});

$(function() {
    $('.show_button').click(function() {
        $('.list-scale').toggleClass('open');
    });
});
